<template>
  <v-card class="pa-5 ml-10 mr-10 mt-5">
    <v-card-title>Module</v-card-title>
    <v-card-text>
      <v-data-table
        hide-default-footer
        items-per-page="20"
        class="border-table"
        density="compact"
        :headers="headers"
        hide-no-data
        item-value="id"
        :items="items">
        <template v-slot:item.active="{ item }">
          <template>
            <v-checkbox
              :disabled="!props.allowedEdit"
              :data-cy="'module-' + item.id + '-active'"
              :true-value="1"
              :false-value="0"
              :model-value="item.slots"
              hide-details>
            </v-checkbox>
            <span v-if="item.monthEnd">(Noch bis zum Ende des Monats)</span>
          </template>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-text>
      <v-row class="mt-5">
        <v-col
          cols="6"
          style="display: grid; justify-content: end"
          >Monatliche Kosten</v-col
        >
        <v-col
          cols="6"
          style="display: grid; justify-content: end">
          <s
            data-cy="old-monthly-costs"
            v-if="oldMonthlyCost !== 0 && oldMonthlyCost !== monthlyCost"
            >{{ oldMonthlyCost }} €</s
          >
          <span data-cy="final-monthly-costs">{{ monthlyCost }} €</span>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions v-if="allowedEdit">
      <v-spacer />
      <v-btn
        v-if="allowedEdit"
        @click="saveModules"
        >Speichern</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { computed, onBeforeMount, onMounted, ref, watch } from "vue";
import { useTranslation } from "i18next-vue";
import { Ref } from "vue";
import { toRaw } from "vue";
import { useMainStore } from "@/stores/mainStore";
import { listModule } from "@/types/global";

const createConfirm = useConfirm();
const createSnackbar = useSnackbar();
const { t } = useTranslation();
const mainStore = useMainStore();

const emit = defineEmits(["moduleUpdate"]);

const props = withDefaults(
  defineProps<{
    allowedEdit: boolean;
    slots: object;
    allSlots;
  }>(),
  { allSlots: {} }
);

defineExpose({
  getInfos
});

const headers: any = computed(() => {
  return [
    {
      title: "Modul",
      align: "start",
      sortable: false,
      key: "module",
      value: (item) => t("views.licence.modules." + item.name + ".name"),
      width: "25%"
    },
    {
      title: "Beschreibung",
      align: "start",
      sortable: false,
      key: "description",
      value: (item) => t("views.licence.modules." + item.name + ".description"),
      width: "25%"
    },
    {
      title: "Aktiv",
      key: "active",
      sortable: false,
      width: "25%",
      hidden: !props.allowedEdit
    },
    {
      title: "slots",
      key: "slots",
      value: (item) => item.slots,
      width: "25%",
      hidden: props.allowedEdit
    },
    {
      title: "Preis pro Monat",
      key: "price",
      sortable: false,
      align: "end",
      value: (item) => {
        console.log(
          item.module,
          item.price,
          Math.floor(item.price) / 100 + " €"
        );
        return Math.floor(item.price) / 100 + " €";
      },
      width: "25%"
    },
    {
      title: "Preis pro Monat (Gesamt)",
      key: "priceAll",
      sortable: false,
      align: "end",
      value: (item) => {
        console.log(
          item.module,
          item.price,
          Math.floor(item.price) / 100 + " €"
        );
        return Math.floor(item.price * item.slots) / 100 + " €";
      },
      width: "25%"
    }
  ].filter((i) => !i.hidden);
});

const oldItems: Ref<Array<listModule>> = computed((prev) => {
  console.log("Previous", prev);
  if (prev && prev.length > 0) return prev;
  let result = [];

  for (const module of mainStore.modules) {
    console.log("Im here,", props.slots[module.value]);
    const element: listModule = Object.assign({}, module, {
      slots: props.slots[module.value],
      monthEnd: props.allSlots[module.value] - props.slots[module.value] || 0
    });

    if (props.slots[module.value] === undefined) {
      return [];
    }

    result.push(element);
  }

  return result;
});

watch(
  props,
  (before, after) => {
    console.log("Here", before.slots, after.slots);
  },
  { deep: true }
);

const items: Ref<Array<listModule>> = computed(() => {
  let result = [];

  for (const module of mainStore.modules) {
    console.log("Im items", props.slots[module.value]);
    const element: listModule = Object.assign({}, module, {
      slots: props.slots[module.value],
      monthEnd: props.allSlots[module.value] - props.slots[module.value] || 0
    });

    result.push(element);
  }

  return result;
});

function getInfos() {
  return {
    monthlyCost: monthlyCost.value,
    additionalCharge: additionalCharge.value,
    modulesRemoved: modulesRemoved.value
  };
}

function saveModules() {
  // saveModules
  console.log("saveModules");

  // TODO save on server
  // payment for remaining days of the month
  //
  createConfirm({
    dialogProps: { width: 400 },
    cardProps: { color: "warning" },
    title: t(`actions.confirmation.change-licence.title`),
    content:
      t(`actions.confirmation.change-licence.content`, {
        newPrice: monthlyCost.value
      }) +
      (additionalCharge.value
        ? t(
            `actions.confirmation.change-licence.module-added`,
            additionalCharge.value
          )
        : "") +
      (modulesRemoved.value.length
        ? t(`actions.confirmation.change-licence.module-removed`, {
            removedModules: modulesRemoved.value
              .map((module) => module.module)
              .join(", ")
          })
        : ""),
    cardTextProps: { style: { "white-space": "pre-wrap" } },
    confirmationText: t(`actions.confirmation.change-licence.confirm`),
    cancellationText: t(`actions.confirmation.change-licence.cancel`)
    // confirmationButtonProps: { color: "warning" }
  }).then((confirm) => {
    if (confirm) {
      emit("moduleUpdate", model.value);
      createSnackbar({
        text: t("actions.deleted"),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 1000 }
      });
    }
  });
}

const oldMonthlyCost = computed(() => {
  return (
    oldItems.value.reduce((acc, module) => {
      acc += module.price * module.slots;
      return acc;
    }, 0) / 100
  );
});

const monthlyCost = computed(() => {
  return (
    items.value.reduce((acc, module) => {
      acc += module.price * module.slots;
      return acc;
    }, 0) / 100
  );
});

const modulesAdded = computed(() => {
  console.log("modulesAdded ", toRaw(items.value), toRaw(oldItems.value));
  return Object.fromEntries(
    items.value.map((module, index) => {
      console.log(module, index, oldItems.value[index]);
      return [module.name, module.slots - oldItems.value[index].slots];
    })
  );
});

const modulesAddedAdditional = computed(() => {
  return Object.fromEntries(
    items.value.map((module, index) => [
      module.name,
      Math.max(module.slots - props.allSlots[module.name], 0)
    ])
  );
});

const modulesRemoved = computed(() => {
  return Object.fromEntries(
    oldItems.value.map((module, index) => [
      module.name,
      module.slots - items.value[index].slots
    ])
  );
});

const additionalCharge = computed(() => {
  {
    const now = new Date();
    const monthDays = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      0
    ).getDate();
    const remainingDays = monthDays - now.getDate() + 1;
    return {
      remainingDays,
      additionalPrice:
        Math.floor(
          mainStore.modules.reduce((acc, module) => {
            acc += module.price * modulesAddedAdditional.value[module.name];
            return acc;
          }, 0) *
            (remainingDays / monthDays)
        ) / 100,
      addedModules: Object.entries(modulesAdded.value)
        .filter(([_, slots]) => slots > 0)
        .map(([name, _]) => name)
        .join(", ")
    };
  }
  return null;
});
</script>
